import { Paper } from '@mui/material'
import StyledContainedButton from 'components/styled/styled-contained-button'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { AddInterestPeriodDialog } from './add-interest-period-dialog'

export const Actions: React.FC = React.memo(() => {
    const { t } = useTranslation()

    const [isAddPeriodDialogOpen, setIsAddPeriodDialogOpen] = React.useState(false)

    return (
        <>
            <Paper elevation={0} sx={{ p: 2 }}>
                <StyledContainedButton
                    variant="contained"
                    color="secondary"
                    onClick={() => setIsAddPeriodDialogOpen(true)}
                >
                    {t('TEXT_ADD_INTEREST_RATE', 'New interest rate period')}
                </StyledContainedButton>
            </Paper>

            <AddInterestPeriodDialog isOpen={isAddPeriodDialogOpen} onClose={() => setIsAddPeriodDialogOpen(false)} />
        </>
    )
})

Actions.displayName = 'Interest-rates-actions'
